import { formatDate, isNumeric, secondsToHMS, yearYoDateString, stripHtml, toWords, notEmptyString } from "../api/helpers";
import { validDateTimeString, validEmail } from "../api/validators";

const prependSymbol = (val, symbol) => {
  let str = '';
  if (typeof val === 'number' && typeof symbol === 'string') {
    str = symbol + val.toFixed(2);
  }
  return str;
}

const addImageSizeSuffix = (src, attrs) => {
  const rgx = /\.(jpe?g|png)$/i;
  if (rgx.test(src)) {
    let { width, height, mode } = attrs;
    if (!mode) {
      mode = 'resize';
    }
    const suffix = [mode, width, height].join("-");
    return src.replace(rgx, "-" + suffix + ".$1");
  }
  return src;
}

const prependCurrency = (val) => {
  return prependSymbol(val, '£')
}

const truncatePlain = (val, maxChars = 200) => {
  let str = stripHtml(val);
  const len = str.length;
  if (len > maxChars) {
    const targetLen = maxChars + 15;
    const cutOff = len > targetLen ? targetLen : len;
    const words = str.substring(0, cutOff).split(' ');
    if (words.length > 20) {
      words.pop();
    }
    str = words.join(' ') + ' ...';
  }
  return str;
}

export const formatFileSize = (bytes) => {
  if (isNumeric(bytes)) {
    bytes = parseInt(bytes);
    if (bytes < 1024) {
      return bytes + ' bytes';
    } else if (bytes < (1024 * 20)) {
      return (bytes / 1024).toFixed(1).replace(/\.0$/, '') + 'KB';
    } else if (bytes < (1024 * 1024)) {
      return (bytes / 1024).toFixed(0) + 'KB';
    } else if (bytes < (20 * 1024 * 1024)) {
      return (bytes / (1024 * 1024)).toFixed(1).replace(/\.0$/, '') + 'MB';
    } else {
      return (bytes / (1024 * 1024)).toFixed(0) + 'MB';
    }
  }
}

export const plainToBreaks = (val) => {
  if (typeof val === 'string') {
    return val.split(/\n/).join("<br />");
  }
  return val;
}

export default {
  filters: {
    currency(val) {
      return prependCurrency(val);
    },
    mailto(val) {
      let str = '#';
      if (validEmail(val)) {
        str = 'mailto:' + val;
      }
      return str;
    },
    mailTooltip(val) {
      return 'email: ' + val
    },
    shortDate(val) {
      return formatDate(val)
    },
    shortDatetime(val) {
      return formatDate(val, 'dd/MM/yyyy HH:mm').replace(/\s+/i, " ");
    },
    toYear(val) {
      const num = validDateTimeString(num) ? formatDate(val, "yyyy") : val;
      if (isNumeric(num)) {
        return parseInt(num);
      } else {
        return -1;
      }
    },
    large(val) {
      return addImageSizeSuffix(val, {
        width: 1920,
        height: 2560
      })
    },
    preview(val) {
      return addImageSizeSuffix(val, {
        width: 640,
        height: 2560
      })
    },
    yesNo(val) {
      return val ? 'yes' : 'no';
    },
    yesNoIcon(val) {
      return val ? 'check' : 'close';
    },
    toWords(val) {
      return toWords(val)
    },
    toLabel(val) {
      if (notEmptyString(val)) {
        val = toWords(val)
          .replace(/shortlisted/g, "in the return-to list")
          .replace(/selected/g, "shortlisted")
          .replace(/unsuccessful\s+(shortlisted)/g, "not $1");
      }
      return val;
    },
    fileSize(val) {
      return formatFileSize(val);
    },
    truncate(val) {
      return truncatePlain(val, 200);
    },
    chars(val) {
      return stripHtml(val).length;
    }
  },
  methods: {
    prependCurrency,
    formatFileSize,
    secondsToHMS,
    yearYoDateString,
    toWords,
    shortDatetime(val) {
      return formatDate(val, 'dd/MM/yyyy HH:mm')
    }
  },
  watch: {
    "$route.path"(val) {
      const parts = val.length > 1 ? val.substring(1).split("/") : [val];
      if (parts.length < 2) {
        if (this.showDetail) {
          this.showDetail = false;
        }
      }
    }
  }
}